import { render } from "./MainIcon.vue?vue&type=template&id=22ea919f&scoped=true"
import script from "./MainIcon.vue?vue&type=script&lang=js"
export * from "./MainIcon.vue?vue&type=script&lang=js"

import "./MainIcon.vue?vue&type=style&index=0&id=22ea919f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22ea919f"]])

export default __exports__